<div
  class="srIrops-itinerary-banner"
  [ngClass]="bannerClass"
>
  <div class="srIrops-itinerary-banner-group1">
    <img
      class="srIrops-itinerary-banner-img"
      src="../../../../../assets/images/infoBlueR.svg" alt="infoIcon"
    >
    <p class="srIrops-itinerary-banner-textMain" [innerHTML]="copyTextMain | translate"></p>
  </div>
  <div *ngIf="showButtonChangeFlight">
    <app-button
      (amClick)="onReviewOptions()"
      theme="iropsRebrandingWhite"
      text="{{ copyButtonBanner | translate}}"
      width="238px" height="60px"
      *ngIf="!reservation?.isEmployee"
    ></app-button>
  </div>
</div>
